<template>
  <div class="form-module">
    <p class="module-title">{{ $locale('schedule.priceRuleTemplate') }}</p>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$locale('global.name') + ' *'" class="w387">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3" v-if="$route.path.indexOf('/rules/') > -1">
        <el-form-item label="数字が小さい順">
          <el-input v-model.number="form.sort" @input="onSortInput" :disabled="$route.path.indexOf('/schedule/edit/') > -1" />
        </el-form-item>
      </el-col>
      <el-col :span="14" v-if="$route.path.indexOf('create') > -1">
        <el-row :gutter="10" style="text-align:right;">
          <el-col :span="1" style="float:right;">
            <el-button class="egl-btn-yellow" @click="$emit('setObj', comRuleList.find(item => item.id === ruleId))">コピー</el-button>
          </el-col>
          <el-col :span="4" style="float:right;">
            <el-select
              v-model="ruleId"
            >
              <el-option
                v-for="item in comRuleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                ></el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ruleTemplateBasicModule",
  inject: ["ruleList"],
  data() {
    return {
      form: {
        name: "",
        sort: 1000,
      },
      ruleId: "",
      // ruleList: [],
      comRuleList: [],
    };
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onSortInput(val) {
      const num = String(val).replace(/[^0-9]/g, "");
      this.form.sort = num === "" ? "" : Number(num);
    },
  },
  computed: {
    injectRuleList() {
      return this.ruleList();
    },
  },
  watch: {
    formObj() {
      this.form = { name: this.formObj.name, sort: this.formObj.sort != null ? this.formObj.sort : 1000 };
      
    },
    injectRuleList(val) {
      if (val.length > 0) {
        this.comRuleList = this.injectRuleList
      }
    }
  },
};
</script>
